"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getAggregationValue: ()=>getAggregationValue,
    fuzzyFilter: ()=>fuzzyFilter,
    highlightCell: ()=>highlightCell
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_table_namespaceObject = require("@tanstack/react-table");
const match_sorter_utils_namespaceObject = require("@tanstack/match-sorter-utils");
const index_cjs_namespaceObject = require("../Text/index.cjs");
const getAggregationValue = (table, columnId, aggregationFn)=>{
    if ('function' == typeof aggregationFn) return aggregationFn(table, columnId);
    const tanStackAggregationFn = react_table_namespaceObject.aggregationFns[aggregationFn];
    const allRows = table.getRowModel().rows;
    return tanStackAggregationFn(columnId, allRows, allRows);
};
const fuzzyFilter = (row, columnId, value, addMeta)=>{
    const itemRank = (0, match_sorter_utils_namespaceObject.rankItem)(row.getValue(columnId), value);
    addMeta({
        itemRank
    });
    return itemRank.passed;
};
const highlightCell = ({ getValue, table }, filterValue)=>{
    const { globalFilter } = table.getState();
    const filter = globalFilter ?? filterValue;
    const value = getValue();
    if (!filter) return value;
    const highlighted = 'string' == typeof filter && value.toLowerCase().includes(filter.toLowerCase()) ? value.split(new RegExp(`(${filter})`, 'gi')).map((part, index)=>part.toLowerCase() === filter.toLowerCase() ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Span, {
            className: "bg-neutral-3",
            palette: "neutral",
            shade: "8",
            bold: true,
            children: part
        }, `${part}-${index}`) : part) : value;
    return highlighted;
};
exports.fuzzyFilter = __webpack_exports__.fuzzyFilter;
exports.getAggregationValue = __webpack_exports__.getAggregationValue;
exports.highlightCell = __webpack_exports__.highlightCell;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "fuzzyFilter",
    "getAggregationValue",
    "highlightCell"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
